// extracted by mini-css-extract-plugin
export var subPageLayout = "SubPageLayout-module--sub-page-layout--c99ab";
export var toc = "SubPageLayout-module--toc--05ba2";